import React from 'react';
import PropTypes from 'prop-types';
import { Row } from '../structure/row';
import { Cell, CENTER } from '../structure/cell';
import Translation from '../../translation/translation';

export const ShowQuantityAndPrice = ({ onShowClick }) => (
    <Row className="show-quantity-and-price">
        <Cell side={CENTER} colSpan={2}>
            <Translation
                translationKey="Show item price or change quantity"
                className="show-quantity-and-price__action"
                onClick={onShowClick}
            />
        </Cell>
    </Row>
);

ShowQuantityAndPrice.propTypes = {
    onShowClick: PropTypes.func.isRequired,
};

ShowQuantityAndPrice.defaultProps = {
    hasBorder: true,
};
